import { createFeatureSelector, createSelector } from '@ngrx/store';

import { UI_PREFERENCES_REDUCER_KEY } from '../reducers/ui-preferences.reducer';
import { UiPreferencesState } from '../states/ui-preferences.state';

const LANDING_PAGE_PREFERENCE_KEY = 'landingPage';
const TASK_MANAGEMENT_PREFERENCE_KEY = 'taskManagement';
const DEFAULT_TENANT_ID_PREFERENCE_KEY = 'defaultTenantId';
const APPS_PREFERENCE_KEY = 'apps';

const getUiPreferencesState = createFeatureSelector<UiPreferencesState>(UI_PREFERENCES_REDUCER_KEY);

/** Full raw preferences object from the backend */
export const getUiPreferences$ = createSelector(getUiPreferencesState, state => state?.preferences);

/** Landing page preference slice (allTenantsPage / tenantPages) */
export const getLandingPagePreference$ = createSelector(
    getUiPreferencesState,
    state => (state?.preferences?.[LANDING_PAGE_PREFERENCE_KEY] as any) ?? null
);

/** Task management preference slice (definitions / instances column configs) */
export const getTaskManagementPreference$ = createSelector(
    getUiPreferencesState,
    state => (state?.preferences?.[TASK_MANAGEMENT_PREFERENCE_KEY] as any) ?? null
);

/** Default tenant ID preference slice */
export const getDefaultTenantIdPreference$ = createSelector(
    getUiPreferencesState,
    state => (state?.preferences?.[DEFAULT_TENANT_ID_PREFERENCE_KEY] as string) ?? null
);

/** Apps / Closure Search configuration preference slice */
export const getAppsPreference$ = createSelector(
    getUiPreferencesState,
    state => (state?.preferences?.[APPS_PREFERENCE_KEY] as Record<string, any>) ?? null
);

export const getUiPreferencesLoading$ = createSelector(getUiPreferencesState, state => state?.loading);

export const getUiPreferencesLoaded$ = createSelector(getUiPreferencesState, state => state?.loaded);

export const getUiPreferencesError$ = createSelector(getUiPreferencesState, state => state?.error);
